class FavoriteButton extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('button');
    if (!this.btn || this._bound) return;
    this._bound = true;
    this.btn.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.dataset.loginUrl) {
      window.location.href = this.dataset.loginUrl;
      return;
    }

    const productId = this.dataset.productId;
    if (!productId) return;

    this.dataset.loading = 'true';

    try {
      const res = await fetch('/apps/favoritos/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ product_id: productId }),
      });

      if (!res.ok) {
        if (res.status === 401) {
          window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
          return;
        }
        throw new Error('Toggle failed: ' + res.status);
      }

      const data = await res.json();
      if (!data.ok) throw new Error(data.error || 'Toggle failed');

      const isFav = data.action === 'added';
      this.dataset.favorited = String(isFav);
      this.btn.setAttribute('aria-pressed', String(isFav));
      this.btn.setAttribute(
        'aria-label',
        isFav ? 'Remover dos favoritos' : 'Adicionar aos favoritos'
      );
      this.btn.setAttribute('title', isFav ? 'Favoritado' : 'Favoritar');

      this.dispatchEvent(
        new CustomEvent('favorite:changed', {
          bubbles: true,
          detail: { productId, favorited: isFav, favorites: data.favorites },
        })
      );
    } catch (err) {
      console.error('[favorites]', err);
    } finally {
      delete this.dataset.loading;
    }
  }
}

if (!customElements.get('favorite-button')) {
  customElements.define('favorite-button', FavoriteButton);
}
